export default "__VITE_ASSET__Bvw2vh8W__"